//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Join.js";
import "../no/TransientObject.js";
import "../no/ugmath.js";
let d=[[],[[[],"Dispose",{},0,0],[[],"GetStackupDirection",{R_:{stackupDirection:''}},0,0],[[],"GetCount",{R_:{stackupCount:''}},0,0],[["i"],"GetEntryPoint",{R_:{coordinates:''}},1,1],[["i"],"GetExitPoint",{R_:{coordinates:''}},1,1],[["i"],"GetConnectedBody",{R_:{body:"Body"}},1,1],[["i","nfaces"],"GetEntryFaces",{R_:{faces:"Face[]"}},1,0],[["i","nfaces"],"GetExitFaces",{R_:{faces:"Face[]"}},1,0],[["nbodies"],"GetConnectedBodies",{R_:{bodies:"Body[]"}},0,0],[["npoints"],"GetEntryPoints",{R_:{points:""}},0,0],[["npoints"],"GetExitPoints",{R_:{points:""}},0,0],[["nEdges"],"GetHoleEdges",{R_:{edges:"Edge[]"}},0,0]],[]];
SPLM.Join.PointJoinStackupInfo = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Join.PointJoinStackupInfo";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Join.PointJoinStackupInfoOptions = class{
    constructor(connectedBodies,entryExitPoints,entryExitFaces,holeEdges){
        this.connectedBodies=connectedBodies;this.entryExitPoints=entryExitPoints;this.entryExitFaces=entryExitFaces;this.holeEdges=holeEdges;}
    get Connectedbodies(){return this.connectedBodies}
    set Connectedbodies(val){this.connectedBodies = val}
    get Entryexitpoints(){return this.entryExitPoints}
    set Entryexitpoints(val){this.entryExitPoints = val}
    get Entryexitfaces(){return this.entryExitFaces}
    set Entryexitfaces(val){this.entryExitFaces = val}
    get Holeedges(){return this.holeEdges}
    set Holeedges(val){this.holeEdges = val}
};

export default SPLM;